import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="announcement"
// Records the dismissal of an "until dismissed" announcement when its alert or modal is closed.
export default class extends Controller {
  static values = {
    dismissUrl: String,
    modalId: String
  };

  connect() {
    this.onAlertClose = () => this.dismiss();
    this.onModalHidden = (event) => {
      if (event.target.id === this.modalIdValue) this.dismiss();
    };

    // The alert is removed from the DOM before `closed.bs.alert`, so listen to `close.bs.alert`.
    this.element.addEventListener('close.bs.alert', this.onAlertClose);
    // The modal controller moves modals out of this element, to the top of the body.
    if (this.hasModalIdValue) document.addEventListener('hidden.bs.modal', this.onModalHidden);
  }

  disconnect() {
    this.element.removeEventListener('close.bs.alert', this.onAlertClose);
    document.removeEventListener('hidden.bs.modal', this.onModalHidden);
  }

  dismiss() {
    if (!this.hasDismissUrlValue || this.dismissed) return;

    this.dismissed = true;
    fetch(this.dismissUrlValue, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
      }
    });
  }
}
